import { AuthMenu as AuthMenuNew } from './AuthMenu';

export const AuthMenu = () => {
  /**
   * Ce menu redirige vers l'ancien site de Score'n'co pour s'authentifier.
   * A supprimer lorsque l'on migrera l'authentification sur la nouvelle
   * version.
   */
  return <AuthMenuNew />;
};
